var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { publish } from "../../messageBus";
import { translate } from "../../translate";
import "./popup.less";
const popupCache = {};
const createElement = (element, className) => {
    const el = document.createElement(element);
    el.className = className;
    return el;
};
const createPopup = (params, closeCallback) => {
    var _a;
    const modalWrapper = createElement("div", "nx-modal");
    const popup = createElement("div", "nx-popup");
    const buttons = [];
    const content = [];
    const buttonsSpecs = (_a = params.buttons) !== null && _a !== void 0 ? _a : [];
    if (params.id !== undefined) {
        popup.id = params.id;
    }
    const closePopup = (choice) => {
        if (params.isError === true) {
            void publish("error-message-dismissed");
        }
        void publish("nx-popup-dismissed", { id: params.id });
        modalWrapper.remove();
        if (params.id !== undefined) {
            popupCache[params.id] = undefined;
        }
        if (closeCallback) {
            closeCallback(choice);
        }
    };
    if (params.content) {
        for (const item of params.content) {
            const messageElement = createElement("div", "nx-popup-message");
            if (item.class !== undefined) {
                messageElement.classList.add(item.class);
            }
            content.push(messageElement);
            popup.appendChild(messageElement);
        }
    }
    if (params.createDefaultOkButton !== undefined && params.createDefaultOkButton !== false) {
        const label = typeof params.createDefaultOkButton === "string"
            ? params.createDefaultOkButton
            : translate("realityCheck.ok");
        buttonsSpecs.push({ label, callback: () => {
                closePopup();
            } });
    }
    if (buttonsSpecs.length > 0) {
        const buttonContainer = createElement("div", "nx-popup-buttons");
        buttonsSpecs.forEach((buttonSpecs) => {
            const button = createElement("button", "nx-popup-button");
            if (buttonSpecs.id !== undefined) {
                button.id = buttonSpecs.id;
            }
            if (buttonSpecs.class !== undefined) {
                button.className = buttonSpecs.class;
            }
            button.innerText = buttonSpecs.label;
            button.addEventListener("click", () => {
                if (buttonSpecs.callback !== undefined) {
                    buttonSpecs.callback();
                }
                if (buttonSpecs.closeValue !== undefined) {
                    closePopup(buttonSpecs.closeValue);
                }
            });
            buttons.push(button);
            buttonContainer.appendChild(button);
        });
        popup.appendChild(buttonContainer);
    }
    modalWrapper.appendChild(popup);
    return {
        specs: params,
        elements: {
            wrapper: modalWrapper,
            content,
            buttons
        },
        close: closePopup
    };
};
const updatePopup = (popup, specs) => {
    var _a;
    if (specs.content) {
        const contentElements = popup.elements.content;
        for (let i = 0; i < contentElements.length; i++) {
            contentElements[i].innerHTML = specs.content[i].html;
        }
    }
    if (!popup.elements.wrapper.parentNode) {
        (_a = document.getElementById("overlay")) === null || _a === void 0 ? void 0 : _a.appendChild(popup.elements.wrapper);
    }
};
const showPopup = (specs) => __awaiter(void 0, void 0, void 0, function* () {
    const overlay = document.getElementById("overlay");
    if (!overlay) {
        return;
    }
    const existingPopup = specs.id !== undefined ? popupCache[specs.id] : undefined;
    if (existingPopup !== undefined) {
        updatePopup(existingPopup, specs);
        return Promise.reject();
    }
    let closeResolve = undefined;
    const closePromise = new Promise((resolve) => {
        closeResolve = resolve;
    });
    const newPopup = createPopup(specs, closeResolve);
    updatePopup(newPopup, specs);
    if (specs.id !== undefined) {
        popupCache[specs.id] = newPopup;
    }
    if (specs.isError === true) {
        void publish("error-message-displayed");
    }
    void publish("nx-popup-displayed", { id: specs.id });
    return closePromise;
});
const hidePopup = (id) => {
    const popup = popupCache[id];
    if (popup === undefined) {
        return;
    }
    popup.close("external");
};
export default {
    show: showPopup,
    hide: hidePopup
};
